<template>
  <div class="content list report-list">
    <div class="row">
      <div class="col-sm-12">
        <el-card style="min-height: 500px">
          <h4 style="color: #3b291d">Process Manage</h4>
          <div class="row">
            <div class="col-sm-4">
              <base-input label="Process">
                <el-select v-model="search_process" class="form-select">
                  <el-option
                    v-for="item in processflows"
                    :key="item"
                    :value="item.value"
                    :label="item.label"
                  ></el-option> </el-select
              ></base-input>
            </div>
            <div class="col-sm-4">
              <!-- <base-input
                label="Contract Number/ Draft Contract Number/Flow Id"
              >
                <el-autocomplete
                  v-model="search_param"
                  :fetch-suggestions="querySearch"
                  :trigger-on-focus="false"
                  clearable
                  class="inline-input w-50"
                  placeholder="Contract Number/ Draft Contract Number/Flow Id"
                  @select="HandlerSelect"
                  @clear="clearHandler"
                />
              </base-input> -->
              <base-input
                label="Contract Number/ Draft Contract Number/Flow Id"
              >
                <el-select
                  filterable
                  v-model="selected_row"
                  class="form-select"
                  @change="HandlerSelect"
                  :filter-method="queryFilter"
                  placeholder="Contract Number/ Draft Contract Number/Flow Id"
                  clearable
                  @clear="clearHandler"
                >
                  <el-option
                    v-for="item in restaurants"
                    :key="item"
                    :value="item"
                    :label="item.value"
                  ></el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-sm-12">
              <base-button type="primary" @click="search">Search</base-button>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table :data="result" style="width: 100%">
              <el-table-column
                prop="processFlowTaskId"
                label="TASKID"
                min-width="150"
              ></el-table-column>
              <el-table-column
                prop="taskName"
                label="TASKNAME"
                min-width="150"
              ></el-table-column>
              <el-table-column
                prop="assignUserId"
                label="ASSIGNUSER"
                min-idth="100"
              ></el-table-column>
              <el-table-column
                prop="flowAssignUserId"
                label="SIGNUSER"
                min-idth="100"
              ></el-table-column>
              <el-table-column label="FLOWSTATUS" min-idth="150">
                <template #default="scope">
                  <div>
                    {{ flowStatusText(scope.row) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="comment" label="REMARK" min-idth="150" />
              <el-table-column
                prop="approveDate"
                label="SIGNTIME"
                min-idth="100"
              >
                <template #default="scope">
                  {{ formatter_datetime(scope.row.approveDate) }}
                </template>
              </el-table-column>
              <el-table-column label="" min-width="150">
                <template #default="scope">
                  <base-button
                    type="danger"
                    v-if="
                      scope.row.taskAction == 'Approve' ||
                      scope.row.taskName == 'END'
                    "
                    style="
                      margin-right: 5px;
                      width: 136px;
                      padding-left: 0px;
                      padding-right: 0px;
                    "
                    :disabled="scope.row?.reject_disable"
                    @click="reject(scope.row)"
                    >Reject</base-button
                  >
                  <base-button
                    type="primary"
                    v-if="scope.row.taskAction == 'Approve'"
                    style="width: 136px; padding-left: 0px; padding-right: 0px"
                    :disabled="scope.row?.approve_disable"
                    @click="approve(scope.row)"
                    >Approve</base-button
                  >
                  <base-button
                    type="primary"
                    v-if="
                      scope.row.taskAction == 'Submit' &&
                      scope.row.taskName != 'END'
                    "
                    style="width: 136px; padding-left: 0px; padding-right: 0px"
                    :disabled="scope.row?.submit_disable"
                    @click="submit(scope.row)"
                    >Submit</base-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import { onMounted, ref } from 'vue';
import { request } from '@/network/request';
import { ElMessage } from 'element-plus';
import { formatter_datetime } from '@/assets/js/formatter.js';
const search_process = ref();
const selected_row = ref();

const restaurants = ref([]);
const queryFilters = ref([]);
const processflows = ref([]);

const queryFilter = (queryString) => {
  if (!queryString) {
    if (!selected_row.value) {
      restaurants.value = [];
      return;
    }
    restaurants.value = [selected_row.value];
    return;
  }

  restaurants.value = queryFilters.value.filter(
    (t) => t.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
  );
};

const loadAll = (name) => {
  request({
    url: 'admin/getProcessFlowSuggests',
    method: 'get',
    params: {
      process_name: name,
    },
  }).then((res) => {
    queryFilters.value = res.data;
  });
};

const result = ref([]);
const search_contract_id = ref('');

onMounted(() => {
  processflows.value = [{ value: 'CONTRACT_PROCESS_BB', label: 'Contract' }];

  search_process.value = processflows.value[0].value;

  loadAll(search_process.value);
});

const HandlerSelect = (item) => {
  search_contract_id.value = selected_row.value.contract_id;
  //selected_row.value = item;
};
const clearHandler = () => {
  result.value = [];
};

const search = () => {
  if (!selected_row.value) {
    ElMessage({
      message: "Please Select 'Contract Number/ Draft Contract Number/Flow Id'",
      type: 'warning',
    });
    return;
  }

  request({
    url: '/admin/getProcessFlowTasks',
    method: 'get',
    params: {
      search_value: selected_row.value.search_value,
      param_key: selected_row.value.param_key,
    },
  }).then((res) => {
    result.value = res.data;
    result.value.map((t) => {
      t.submit_disable = t.approve_disable = t.reject_disable = true;

      if (t?.allow_action?.includes('Approve')) {
        t.approve_disable = false;
      }
      if (t?.allow_action?.includes('Submit')) {
        t.submit_disable = false;
      }
      if (
        t?.allow_action?.includes('Reject') ||
        t?.allow_action?.includes('Reject_Admin')
      ) {
        t.reject_disable = false;
      }
    });
  });
};

const reject = async (row) => {
  var process_flow_id = row.processFlowId;
  var process_task_id = row.processFlowTaskId ?? 'none';
  approveProcess(process_flow_id, process_task_id, 'Reject_Admin');
};

const approve = async (row) => {
  var process_flow_id = row.processFlowId;
  var process_task_id = row.processFlowTaskId ?? '';
  approveProcess(process_flow_id, process_task_id, 'Accept');
};

const submit = async (row) => {
  approveProcess(row.processFlowId, row.processFlowTaskId, 'Submit');
};

const approveProcess = async (
  process_flow_id,
  process_task_id,
  approve_action
) => {
  var comment = '系统处理';
  if (approve_action == 'Submit') {
    comment = '';
  }
  request({
    url: '/admin/ApproveProcess',
    method: 'post',
    params: {
      process_flow_id,
      process_task_id,
      comment,
      approve_action,
    },
  }).then((res) => {
    if (!res.data?.message || res.data.message === 'OK') {
      ElMessage({
        message: 'success.',
        type: 'success',
      });

      search();
    } else {
      ElMessage({
        message: res.data.message,
        type: 'warning',
      });
    }
  });
};

const flowStatusText = (row) => {
  if (row.taskAction == 'Submit') {
    if (row.flowStatus == 'Processed') {
      return 'Submitted';
    } else {
      return 'No Submit';
    }
  } else if (row.taskAction == 'Approve') {
    if (row.flowStatus == 'Processed') {
      return 'Approved';
    } else if (row.flowStatus == '') {
      if (row.action == 'Reject') {
        return 'Rejected';
      }
      return '';
    }
  }
  return row.flowStatus;
};
</script>
<style>
.form-group .form-select .el-input__inner {
  background-color: #fff !important;
}
</style>
